

export class ValidateTenantUtils {
  public static username = null;
  public static tenant = null;
  public static systemType = "IEX";

  public static recordTenant(subdomain: string) {
    ValidateTenantUtils.tenant = subdomain;
    ValidateTenantUtils.report();
  }
  public static recordUser(usernameHash){
    ValidateTenantUtils.username = usernameHash;
    ValidateTenantUtils.report();
  }

  public static getRegion(hostname: string = window.location.hostname): string {
    try {
      const parts = hostname.split('.');

      // IEX: <subdomain>.<area_id>.nice-esp.com
      if (hostname.includes('nice-esp')) {
        return parts.length >= 4 ? parts[parts.length - 3] : '';
      }

      // CXone: <area_id>.nicecxone.com, <area_id>.nice-incontact.com, <area_id>.niceincontact.com
      if (hostname.includes('nicecxone') || hostname.includes('niceincontact') || hostname.includes('nice-incontact')) {
        return parts[0];
      }
    } catch (e) {
      // ignore parsing errors
    }

    return '';
  }

  public static report(){
    if ((window as any).aptrinsic &&
      ValidateTenantUtils.tenant &&
      ValidateTenantUtils.username) {
      const region = ValidateTenantUtils.getRegion();
      (window as any).aptrinsic('identify',{
        id: ValidateTenantUtils.tenant + "-"+ ValidateTenantUtils.username,
        firstName:ValidateTenantUtils.tenant,
        lastName:ValidateTenantUtils.systemType,
        countryCode: region

      },{
        id: ValidateTenantUtils.tenant,
        name: ValidateTenantUtils.tenant,
        countryCode: region

      })
    }
  }
}
